import { EXPRESSION_TYPES } from '@willow/types-iso';

import { functionFrom, FunctionLibrary, getFunctionSignature } from '../FunctionDefinition';

const ifNumber = functionFrom(
  'if',
  [
    { name: 'condition', type: EXPRESSION_TYPES.boolean },
    { name: 'thenValue', type: EXPRESSION_TYPES.number, isLazy: true },
    { name: 'elseValue', type: EXPRESSION_TYPES.number, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.number,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

const ifString = functionFrom(
  'if',
  [
    { name: 'condition', type: EXPRESSION_TYPES.boolean },
    { name: 'thenValue', type: EXPRESSION_TYPES.string, isLazy: true },
    { name: 'elseValue', type: EXPRESSION_TYPES.string, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.string,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

const ifDuration = functionFrom(
  'if',
  [
    { name: 'condition', type: EXPRESSION_TYPES.boolean },
    { name: 'thenValue', type: EXPRESSION_TYPES.duration, isLazy: true },
    { name: 'elseValue', type: EXPRESSION_TYPES.duration, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.duration,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

const ifPlainDate = functionFrom(
  'if',
  [
    { name: 'condition', type: EXPRESSION_TYPES.boolean },
    { name: 'thenValue', type: EXPRESSION_TYPES.plainDate, isLazy: true },
    { name: 'elseValue', type: EXPRESSION_TYPES.plainDate, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.plainDate,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

const ifPlainTime = functionFrom(
  'if',
  [
    { name: 'condition', type: EXPRESSION_TYPES.boolean },
    { name: 'thenValue', type: EXPRESSION_TYPES.plainTime, isLazy: true },
    { name: 'elseValue', type: EXPRESSION_TYPES.plainTime, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.plainTime,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

const ifZonedDateTime = functionFrom(
  'if',
  [
    { name: 'condition', type: EXPRESSION_TYPES.boolean },
    { name: 'thenValue', type: EXPRESSION_TYPES.zonedDateTime, isLazy: true },
    { name: 'elseValue', type: EXPRESSION_TYPES.zonedDateTime, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.zonedDateTime,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

export const LOGICAL_FUNCTIONS = {
  [getFunctionSignature(ifNumber)]: ifNumber,
  [getFunctionSignature(ifString)]: ifString,
  [getFunctionSignature(ifPlainDate)]: ifPlainDate,
  [getFunctionSignature(ifPlainTime)]: ifPlainTime,
  [getFunctionSignature(ifZonedDateTime)]: ifZonedDateTime,
  [getFunctionSignature(ifDuration)]: ifDuration,
} satisfies FunctionLibrary;
